
export const submitRmaData = async (params, lang) => {
    try {
        console.log("Sending data:", params);
        const apiUrl = `${process.env.VUE_APP_API_URL}/rma/return`;
        console.log(apiUrl)
        const requestOptions = {
            method: "POST",
            headers: { 
                "Content-Type": "application/json" ,
                "Accept-Language": lang
            },
            body: JSON.stringify(params),
        };

        const response = await fetch(apiUrl, requestOptions);
        console.log(response)

        if (!response.ok) {
            throw new Error(`${response.statusText}`);
        }

        return await response.json(); // Return API response

    } catch (error) {
        console.error("Error sending order data:", error);
        throw error;
    }
};
